import { CircleSkeleton, Skeleton } from '@/_components';
import { CardContainer, ImageTextHeader, PageHeaderCtrlContainer } from '@/_containers';
import { PageHeaderContainer } from '@/_containers/headers/page/page-header-container';

export function HeaderLoading() {
  return (
    <CardContainer bodyClassName="flex">
      <PageHeaderContainer>
        <ImageTextHeader
          imageSlot={<CircleSkeleton className="size-28" />}
          primarySlot={<Skeleton className="mt-2 h-7 w-44" />}
          secondarySlot={<Skeleton className="mt-1 h-5 w-36" />}
          tertiarySlot={
            <PageHeaderCtrlContainer className="ml-0">
              <Skeleton className="h-6 w-24" />
              <div className="border-c-border-muted h-5 w-px border-r" />
              <Skeleton className="h-6 w-24" />
            </PageHeaderCtrlContainer>
          }
        />
      </PageHeaderContainer>
    </CardContainer>
  );
}
